import { render, staticRenderFns } from "./IntegracaoMensagem.vue?vue&type=template&id=d4d3afbe&"
import script from "./IntegracaoMensagem.vue?vue&type=script&lang=js&"
export * from "./IntegracaoMensagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "IntegracaoMensagem.vue"
export default component.exports